<template>
  <div class="detail_container">
    <v-container class="scheme_node_pipes">
      <v-data-table
        :calculate-widths="true"
        :headers="headers"
        :items="$store.state.SchemeNodePipesModule.listEntries"
        :loading="$store.state.SchemeNodePipesModule.loadingList"
        :items-per-page="-1"
        class="elevation-1 scheme_node_pipes__table"
        hide-default-footer
        loading-text="Загрузка..."
        sort-by="name_ru"
        @click:row="editItem"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title class="scheme_node_pipes__header"
              >Легенда узлов отопления — трубопроводы</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="addNewEntry"
                >
                  Добавить
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h6 d-block text-center">{{
                  formTitle
                }}</v-card-title>
                <v-card-text class="scheme_node_pipes__modal_item">
                  <InputStyledSimple
                    :data="editedItem.code"
                    :is-loading="$store.state.SchemeNodePipesModule.loadingList"
                    :is-disabled="$store.state.SchemeNodePipesModule.loadingList"
                    placeholder="code (уникальный, напр. heating_flow)"
                    @update-input="editedItem.code = $event"
                  />
                  <div class="scheme_node_pipes__marking_row">
                    <InputStyledSimple
                      :data="editedItem.marking_ru"
                      :is-loading="$store.state.SchemeNodePipesModule.loadingList"
                      :is-disabled="$store.state.SchemeNodePipesModule.loadingList"
                      placeholder="Маркировка RU (напр. ОП)"
                      @update-input="editedItem.marking_ru = $event"
                    />
                    <InputStyledSimple
                      :data="editedItem.marking_en"
                      :is-loading="$store.state.SchemeNodePipesModule.loadingList"
                      :is-disabled="$store.state.SchemeNodePipesModule.loadingList"
                      placeholder="Маркировка EN (напр. HF)"
                      @update-input="editedItem.marking_en = $event"
                    />
                  </div>
                  <InputStyledSimple
                    :data="editedItem.name_ru"
                    :is-loading="$store.state.SchemeNodePipesModule.loadingList"
                    :is-disabled="$store.state.SchemeNodePipesModule.loadingList"
                    placeholder="Название RU"
                    @update-input="editedItem.name_ru = $event"
                  />
                  <InputStyledSimple
                    :data="editedItem.name_en"
                    :is-loading="$store.state.SchemeNodePipesModule.loadingList"
                    :is-disabled="$store.state.SchemeNodePipesModule.loadingList"
                    placeholder="Название EN"
                    @update-input="editedItem.name_en = $event"
                  />

                  <div class="scheme_node_pipes__color_field">
                    <v-menu
                      v-model="colorMenu"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="scheme_node_pipes__swatch scheme_node_pipes__swatch--picker"
                          :style="{ background: editedItem.color }"
                          v-bind="attrs"
                          v-on="on"
                        ></span>
                      </template>
                      <v-color-picker
                        :value="editedItem.color"
                        mode="hexa"
                        hide-mode-switch
                        @update:color="setColorFromPicker"
                      ></v-color-picker>
                    </v-menu>
                    <InputStyledSimple
                      :data="editedItem.color"
                      :is-loading="$store.state.SchemeNodePipesModule.loadingList"
                      :is-disabled="$store.state.SchemeNodePipesModule.loadingList"
                      placeholder="Цвет (hex)"
                      @update-input="editedItem.color = $event"
                    />
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="blue darken-1" text class="mr-auto" @click="dialog = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    color="blue"
                    text
                    :loading="$store.state.SchemeNodePipesModule.loadingList"
                    :disabled="
                      !editedItem.code ||
                      !editedItem.name_ru ||
                      !editedItem.name_en ||
                      !editedItem.color ||
                      $store.state.SchemeNodePipesModule.loadingList
                    "
                    @click="saveEntry"
                  >
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogDelete" max-width="500">
              <v-card>
                <v-card-title class="text-h6 d-block text-center"
                  >Удалить трубу «{{ editedItem.name_ru }}»?</v-card-title
                >
                <v-card-actions>
                  <v-btn color="blue darken-1" text class="mr-auto" @click="dialogDelete = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    color="red darken-1"
                    text
                    :loading="$store.state.SchemeNodePipesModule.loadingList"
                    @click="deleteEntryConfirmed"
                  >
                    Удалить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.color="{ item }">
          <div class="scheme_node_pipes__color_cell">
            <span
              class="scheme_node_pipes__swatch"
              :style="{ background: item.color }"
            ></span>
            <span class="scheme_node_pipes__hex">{{ item.color }}</span>
          </div>
        </template>

        <template v-slot:item.marking="{ item }">
          {{ item.marking_ru }} / {{ item.marking_en }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click.stop="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click.stop="deleteItem(item)"> mdi-delete </v-icon>
        </template>

        <template v-slot:no-data> Легенда пуста </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import InputStyledSimple from "@/components/common/InputStyledSimple";
import { SchemeNodePipe } from "@/helpers/constructors";

export default {
  name: "SchemeNodePipes",
  components: { InputStyledSimple },
  data: () => ({
    headers: [
      { text: "Цвет", value: "color", sortable: false, width: "110px" },
      { text: "code", value: "code", sortable: true, width: "16%" },
      { text: "Марк. RU / EN", value: "marking", sortable: false, width: "14%" },
      { text: "Название RU", value: "name_ru", sortable: true, width: "24%" },
      { text: "Название EN", value: "name_en", sortable: true, width: "22%" },
      { text: "", value: "actions", sortable: false, width: "10%" },
    ],
    dialog: false,
    dialogDelete: false,
    colorMenu: false,
    editedItem: new SchemeNodePipe(),
  }),
  computed: {
    formTitle() {
      return this.editedItem.id ? "Редактирование трубы" : "Новая труба";
    },
  },
  async mounted() {
    await this.$store.dispatch("SchemeNodePipesModule/getListEntries");
  },
  watch: {
    dialog(state) {
      if (!state) this.editedItem = new SchemeNodePipe();
    },
  },
  methods: {
    addNewEntry() {
      this.editedItem = new SchemeNodePipe();
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedItem = item;
      this.dialogDelete = true;
    },
    setColorFromPicker(value) {
      this.editedItem.color = (value && value.hex ? value.hex : value || "").toUpperCase();
    },
    async saveEntry() {
      const response = await this.$store.dispatch(
        "SchemeNodePipesModule/onSubmit",
        this.editedItem
      );
      if (response && !response.isError) this.dialog = false;
    },
    async deleteEntryConfirmed() {
      await this.$store.dispatch(
        "SchemeNodePipesModule/deleteEntry",
        this.editedItem.id
      );
      this.dialogDelete = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.scheme_node_pipes {
  &__header {
    font-size: 1em;
  }
  &__table {
    ::v-deep tbody tr {
      cursor: pointer;
    }
  }
  &__modal_item {
    display: grid;
    gap: 22px;
    padding-top: 1.5em !important;
    padding-bottom: 1em !important;
  }
  &__marking_row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  &__color_field {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  &__color_cell {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }
  &__swatch {
    width: 28px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: inline-block;
    flex: none;
    &--picker {
      cursor: pointer;
      width: 36px;
      height: 36px;
      border-radius: 6px;
    }
  }
  &__hex {
    font-family: monospace;
    font-size: 0.85em;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
